module.exports = __webpack_public_path__ + "img/icon-phone.7fd24549.svg";